import {Component, Input} from '@angular/core';
import {routesNames} from "@app/app-routing.module";
import {CartDetail} from '@app/core/cart/domain/dtos/cart-detail';
import {IsPriceHiddenUseCase} from '@app/core/delivery-point/application/is-price-hidden.use-case';
import {LocalizedRouter} from "@app/presentation/services/localized-router";

@Component({
  selector: 'app-cart-summary',
  templateUrl: './cart-summary.component.html',
  styleUrls: ['./cart-summary.component.scss']
})
export class CartSummaryComponent {

  @Input() cartDetail?: CartDetail | null;

  isPriceHidden$ = this.isPriceHiddenUseCase.execute();

  constructor(
    private isPriceHiddenUseCase: IsPriceHiddenUseCase,
    private localizedRouter: LocalizedRouter
  ) { }

  goToCheckout() {
    this.localizedRouter.navigate(['/', routesNames.checkout])
  }
}
